import { durationToSeconds } from "@silo/utils";

export const TTL = {
  ONE_DAY: durationToSeconds({ days: 1 }),
  ONE_MINUTE: durationToSeconds({ minutes: 1 }),
  FIVE_MINUTES: durationToSeconds({ minutes: 5 }),
  TEN_MINUTES: durationToSeconds({ minutes: 10 }),
};
